<div class="ms-auto">
  <ul class="list-unstyled">

    <!-- ── Current page's date-range pill (e.g. document dashboard) ───────── -->
    <li class="pc-h-item" *ngIf="pillText">
      <span class="header-date-pill">
        <i class="ti ti-calendar"></i>
        {{ pillText }}
      </span>
    </li>

    <!-- ── Referral Queue Notifications ────────────────────────────────── -->
    <li class="pc-h-item">
      <div class="notif-wrap" (click)="toggleNotif($event)">
        <!-- Bell trigger -->
        <button
          class="notif-btn"
          [class.notif-btn--active]="notifOpen"
          nz-tooltip
          nzTooltipTitle="Referral Queue"
          [nzTooltipMouseEnterDelay]="0.6"
        >
          <i class="ti ti-bell"></i>
          @if (notifBadge > 0) {
            <span class="notif-badge">
              {{ notifBadge > 99 ? '99+' : notifBadge }}
            </span>
          }
        </button>

        <!-- Dropdown panel -->
        @if (notifOpen) {
          <div class="notif-panel" (click)="$event.stopPropagation()">
            <div class="notif-panel-header">
              <div>
                <div class="notif-panel-title">Referral Queue</div>
                <div class="notif-panel-sub">Live updates via SignalR</div>
              </div>
              <span class="notif-live-dot"></span>
            </div>
            <div class="notif-panel-body">
              <!-- Packet Buckets — same items/counts as the sidebar submenu -->
              @for (p of packetItems; track p.bucket) {
                <a
                  class="notif-item"
                  [routerLink]="['/incoming-referral']"
                  [queryParams]="{ bucket: p.bucket }"
                  (click)="notifOpen = false"
                >
                  <div class="notif-item-icon" [ngClass]="p.tone"><span nz-icon [nzType]="p.icon"></span></div>
                  <div class="notif-item-info">
                    <span class="notif-item-label">{{ p.bucket }}</span>
                    <span class="notif-item-desc">{{ p.description }}</span>
                  </div>
                  <span class="notif-item-val" [ngClass]="p.tone">{{ packetCounts[p.bucket] ?? 0 }}</span>
                </a>
              }
              <div class="notif-divider"></div>
              <a class="notif-item" [routerLink]="['/exception-queue']" (click)="notifOpen = false">
                <div class="notif-item-icon orange"><i class="ti ti-shield-exclamation"></i></div>
                <div class="notif-item-info">
                  <span class="notif-item-label">Exceptions</span>
                  <span class="notif-item-desc">Require resolution</span>
                </div>
                <span class="notif-item-val orange">{{ excSummary.total }}</span>
              </a>
              <a class="notif-item" [routerLink]="['/exception-queue']" [queryParams]="{ type: 'Non Referral' }" (click)="notifOpen = false">
                <div class="notif-item-icon grey"><i class="ti ti-file-unknown"></i></div>
                <div class="notif-item-info">
                  <span class="notif-item-label">Non Referral</span>
                  <span class="notif-item-desc">Unclassified documents</span>
                </div>
                <span class="notif-item-val grey">{{ excSummary.nonReferral }}</span>
              </a>
            </div>
            <a
              class="notif-panel-footer"
              [routerLink]="['/incoming-referral']"
              [queryParams]="{ bucket: allReferralsBucket }"
              (click)="notifOpen = false"
            >
              View all referrals
              <i class="ti ti-arrow-right"></i>
            </a>
          </div>
        }
      </div>
    </li>

    <!-- Filter icon — only visible when the current page registers filters -->
    @if (hasFilter) {
      <li class="pc-h-item">
        <button class="filter-toggle-btn" (click)="openFilter()" nz-tooltip nzTooltipTitle="Page Filters" [nzTooltipMouseEnterDelay]="0.6">
          <i class="ti ti-adjustments-horizontal"></i>
        </button>
      </li>
    }

    <!-- Dark / Light theme toggle (adminHMD style) -->
    <li class="pc-h-item">
      <button class="theme-toggle-btn" (click)="toggleDark()" [title]="isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
        @if (!isDark) {
          <svg
            viewBox="0 0 24 24"
            width="17"
            height="17"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        }
        @if (isDark) {
          <svg
            viewBox="0 0 24 24"
            width="17"
            height="17"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
          </svg>
        }
      </button>
    </li>
    <li>
      <!-- <div class="dropdown pc-h-item" ngbDropdown>
      <a
        class="pc-head-link head-link-secondary dropdown-toggle arrow-none me-0"
        data-bs-toggle="dropdown"
        href="javascript:"
        ngbDropdownToggle
        >
        <i class="ti ti-bell"></i>
      </a>
      <div class="dropdown-menu dropdown-notification dropdown-menu-end pc-h-dropdown" ngbDropdownMenu>
        <div class="dropdown-header">
          <a href="javascript:!" class="link-primary float-end text-decoration-underline">Mark as all read</a>
          <h5>
            All Notification
            <span class="badge bg-warning rounded-pill ms-1">01</span>
          </h5>
        </div>
        <ng-scrollbar style="height: calc(100vh - 215px)" visibility="hover">
          <div class="dropdown-header px-0 text-wrap">
            <div class="list-group list-group-flush w-100">
              <div class="list-group-item">
                <select class="form-select">
                  <option value="all">All Notification</option>
                  <option value="new">New</option>
                  <option value="unread">Unread</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <a class="list-group-item list-group-item-action">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <img src="assets/images/user/avatar-2.jpg" alt="user-image" class="user-avtar" />
                  </div>
                  <div class="flex-grow-1 ms-1">
                    <span class="float-end text-muted">2 min ago</span>
                    <h5>John Doe</h5>
                    <p class="text-body fs-6">It is a long established fact that a reader will be distracted</p>
                    <div class="badge rounded-pill bg-light-danger">Unread</div>
                    <div class="badge rounded-pill bg-light-warning">New</div>
                  </div>
                </div>
              </a>
              <a class="list-group-item list-group-item-action">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <div class="user-avtar bg-light-success"><i class="ti ti-building-store"></i></div>
                  </div>
                  <div class="flex-grow-1 ms-1">
                    <span class="float-end text-muted">3 min ago</span>
                    <h5>Store Verification Done</h5>
                    <p class="text-body fs-6">We have successfully received your request.</p>
                    <div class="badge rounded-pill bg-light-danger">Unread</div>
                  </div>
                </div>
              </a>
              <a class="list-group-item list-group-item-action">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <div class="user-avtar bg-light-primary"><i class="ti ti-mailbox"></i></div>
                  </div>
                  <div class="flex-grow-1 ms-1">
                    <span class="float-end text-muted">5 min ago</span>
                    <h5>Check Your Mail.</h5>
                    <p class="text-body fs-6">All done! Now check your inbox as you're in for a sweet treat!</p>
                    <button class="btn btn-sm btn-primary">
                      Mail
                      <i class="ti ti-brand-telegram"></i>
                    </button>
                  </div>
                </div>
              </a>
              <a class="list-group-item list-group-item-action">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <img src="assets/images/user/avatar-1.jpg" alt="user-image" class="user-avtar" />
                  </div>
                  <div class="flex-grow-1 ms-1">
                    <span class="float-end text-muted">8 min ago</span>
                    <h5>John Doe</h5>
                    <p class="text-body fs-6">
                      Uploaded two file on &nbsp;
                      <strong>21 Jan 2020</strong>
                    </p>
                    <div class="notification-file d-flex p-3 bg-light-secondary rounded">
                      <i class="ti ti-arrow-bar-to-down"></i>
                      <h5 class="m-0">demo.jpg</h5>
                    </div>
                  </div>
                </div>
              </a>
              <a class="list-group-item list-group-item-action">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <img src="assets/images/user/avatar-3.jpg" alt="user-image" class="user-avtar" />
                  </div>
                  <div class="flex-grow-1 ms-1">
                    <span class="float-end text-muted">10 min ago</span>
                    <h5>Joseph William</h5>
                    <p class="text-body fs-6">It is a long established fact that a reader will be distracted</p>
                    <div class="badge rounded-pill bg-light-success">Confirmation of Account</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </ng-scrollbar>
        <div class="dropdown-divider"></div>
        <div class="text-center py-2">
          <a href="javascript:" class="link-primary">Mark as all read</a>
        </div>
      </div>
    </div> -->
    </li>
    <li>
      <div class="dropdown pc-h-item header-user-profile" ngbDropdown>
        <a class="header-user-trigger arrow-none" href="javascript:" ngbDropdownToggle>
          <div class="user-avatar-badge">{{ userInitials || '?' }}</div>
          <div class="header-user-meta">
            <span class="header-user-name">{{ username || 'User' }}</span>
            <span class="header-user-role">{{ roleDisplay }}</span>
          </div>
          <i class="ti ti-chevron-down header-user-caret"></i>
        </a>
        <div class="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown" ngbDropdownMenu>
          <div class="dropdown-header">
            <div class="user-dropdown-info">
              <div class="user-avatar-badge sm">{{ userInitials || '?' }}</div>
              <div>
                <div class="user-dropdown-name">{{ username || 'User' }}</div>
                <div class="user-dropdown-email">{{ email }}</div>
              </div>
            </div>
            <div class="dropdown-divider my-1"></div>
            @if (showManagement) {
              <a [routerLink]="['/user-list']" class="dropdown-item">
                <i class="ti ti-users"></i>
                <span>User Management</span>
              </a>
            }
            <a (click)="onChangePwd()" class="dropdown-item">
              <i class="ti ti-settings"></i>
              <span>Change Password</span>
            </a>
            <a (click)="onTFASettings()" class="dropdown-item">
              <i class="ti ti-key"></i>
              <span>{{ showTFA ? 'Disable MFA' : 'Enable MFA' }}</span>
            </a>
            <div class="dropdown-divider my-1"></div>
            <a (click)="onLogoutClick()" class="dropdown-item text-danger-item">
              <i class="ti ti-logout"></i>
              <span>Logout</span>
            </a>
          </div>
        </div>
      </div>
    </li>
  </ul>
  @if (isCPVisible) {
    <change-pwd-modal [isVisible]="isCPVisible" (closeModalEvent)="onCPCloseModalEvent($event)"></change-pwd-modal>
  }
  @if (isTFAVisible) {
    <tfa-modal [mfaEnabled]="mfaEnabled" [isVisible]="isTFAVisible" (closeModalEvent)="onTFACloseModalEvent($event)"></tfa-modal>
  }
</div>
